import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseTabsContainer, TabsContainerService, UserService } from 'yt-ng-framework';
import { KomitentUgovor } from './komitent-ugovor';

@Component({
  selector: 'yt-komitent-ugovor-tabs',
  templateUrl: './komitent-ugovor-tabs.component.html'
})
export class KomitentUgovorTabsComponent extends BaseTabsContainer<KomitentUgovor> implements OnInit {

  constructor(
    public tabsContainerService: TabsContainerService<KomitentUgovor>,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService
  ) { 
    super(tabsContainerService, activatedRoute, userService)
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
